import { SupportedLanguages } from '@src/@data/utility/supportedLanguages';

export const getPrivacyPolicyLink = (language: SupportedLanguages) => {
  return `https://bookla.com/${language}/privacy-policy`;
};
